<template>

  <section class="application-create__form">
    <div class="container-xxxl">
      <div class="row">
        <div class="col-xxl-6 offset-xxl-3">
          <h3 class="application__form__title">{{ $lang.app.INVOICE_FOR_PAYMENT }}</h3>
          <div v-for="(payment, index) in application.payments" :key="index"
               class="application__form__block">
            <h4 class="add__fields__title">{{ $lang.app.DOCUMENTS }}</h4>
            <div class="add__field__list">
              <div class="row">
                <div v-if="payment.attachmentToAgreement" class="col-lg-6">
                  <div class="add__field__item">
                    <div class="add__field__header">
                      {{ $lang.app.SUPPLEMENT }}
                    </div>
                    <div class="stack__list mb-2">
                      <div class="stack__label">{{ $lang.app.FILE }}</div>
                      <button type="button" class="file__item w-full"
                              @click.prevent="$emitter.emit('open-applicant-application-pdf-file', payment.attachmentToAgreement)">
                        <svg viewBox="0 0 24 24" width="24" height="24">
                          <use xlink:href="@/assets/v2/img/sprite.svg#icon__file__pdf"></use>
                        </svg>
                        <span class="file__item__name">
                        {{ payment.attachmentToAgreement?.filename }}
                      </span>
                      </button>
                    </div>
                    <button v-if="payment.signDate === null" type="button"
                            class="button button--default button--bordered button--full mb2"
                            @click.prevent="$emitter.emit('open-sign-payment-modal', {applicationId: application.id, paymentId: payment.id})">
                      {{ $lang.app.SIGN_DOCUMENT }}
                    </button>
                  </div>
                </div>
                <div v-if="payment.payment" class="col-lg-6">
                  <div class="add__field__item">
                    <div class="add__field__header">
                      {{ $lang.app.INVOICE_FOR_PAYMENT }}
                    </div>
                    <div class="stack__list mb-2">
                      <div class="stack__label">{{ $lang.app.FILE }}</div>
                      <button type="button" class="file__item w-full"
                              @click.prevent="$emitter.emit('open-applicant-application-pdf-file', payment.payment)">
                        <svg viewBox="0 0 24 24" width="24" height="24">
                          <use xlink:href="@/assets/v2/img/sprite.svg#icon__file__pdf"></use>
                        </svg>
                        <span class="file__item__name">
                        {{ payment.payment?.filename }}
                      </span>
                      </button>
                    </div>
                  </div>
                </div>
                <div v-if="payment.paymentOrder" class="col-lg-6">
                  <div class="add__field__item">
                    <div class="add__field__header">
                      {{ $lang.app.PAYMENT_ORDER }}
                    </div>
                    <div class="stack__list mb-2">
                      <div class="stack__label">{{ $lang.app.FILE }}</div>
                      <button type="button" class="file__item w-full"
                              @click.prevent="$emitter.emit('open-applicant-application-pdf-file', payment.paymentOrder)">
                        <svg viewBox="0 0 24 24" width="24" height="24">
                          <use xlink:href="@/assets/v2/img/sprite.svg#icon__file__pdf"></use>
                        </svg>
                        <span class="file__item__name">
                        {{ payment.paymentOrder?.filename }}
                      </span>
                      </button>
                    </div>
                  </div>
                </div>
                <div v-if="payment.receipt" class="col-lg-6">
                  <div class="add__field__item">
                    <div class="add__field__header">
                      {{ $lang.app.RECEIPT }}
                    </div>
                    <div class="stack__list mb-2">
                      <div class="stack__label">{{ $lang.app.FILE }}</div>
                      <button type="button" class="file__item w-full"
                              @click.prevent="$emitter.emit('open-applicant-application-pdf-file', payment.receipt)">
                        <svg viewBox="0 0 24 24" width="24" height="24">
                          <use xlink:href="@/assets/v2/img/sprite.svg#icon__file__pdf"></use>
                        </svg>
                        <span class="file__item__name">
                        {{ payment.receipt?.filename }}
                      </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="!payment.receipt && payment.payment && hasAction('APPLICANT_PAYMENT_ACTION')" class="input__group">
              <button type="button" class="button button--full button__icon--left button--default button--bordered button__add__5__doc"
                      @click="$emitter.emit('open-applicant-application-payment-receipt-upload-modal', payment)">
                <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
                  <use xlink:href="@/assets/v2/img/sprite.svg#icon__plus"></use>
                </svg>
                <span class="button__text">{{ $lang.app.PAY }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SignPaymentModal/>
    <PaymentReceiptUploadModal/>
  </section>

</template>
<script>
import SignPaymentModal from "@/components/applicant/application/modals/SignPaymentModal";
import PaymentReceiptUploadModal from "@/components/applicant/application/modals/PaymentReceiptUploadModal";

export default {
  name: "ApplicantApplicationPaymentsDetail",
  components: {
    SignPaymentModal,
    PaymentReceiptUploadModal,
  },
  props: {
    application: Object,
  },
  methods: {
    hasAction(action) {
      return this.application.actions.some(item => item.constName === action)
    },
  }
};
</script>
